<button
  mat-button
  [disableRipple]="true"
  *ngIf="!isLocationsLoading"
  color="progressive"
  class="chip-btn filter-btn"
  (click)="hideFilter = !hideFilter"
  onclick="this.blur()"
  aria-label="filters">
  <saj-icon-filter class="children:h-[16px]"></saj-icon-filter>
  <span class="filter-text">Filters</span>
</button>
<mat-drawer-container
  class="multi-filter-drawer-container"
  [class.hidden]="hideFilter"
  [style.height]="innerWindowHeight">
  <mat-drawer
    #drawer
    class="multi-filter-drawer"
    mode="over"
    position="end"
    [opened]="!hideFilter"
    (closedStart)="startDelayedDrawerClose()"
    (openedStart)="drawerOpening()"
    [autoFocus]="false">
    <div class="drawer-contents">
      <div class="multi-filter-header">
        <h3 class="header">Filters</h3>
        <span
          tabindex="0"
          aria-label="close"
          class="icon-functional icon-close"
          (click)="drawer.toggle()"
          (keydown.enter)="drawer.toggle()"></span>
      </div>
      <div *ngIf="filterState.hasFilters" class="filter-container">
        <div *ngFor="let state of filterState.states" class="filter">
          <filter-header
            [isExpanded]="state.filter.isExpanded"
            [selectedOptionsCount]="state.selectedOptionsCount"
            [headingText]="state.filter.headingText"
            (expandedChanged)="state.filter.isExpanded = $event">
          </filter-header>

          <div
            [ngSwitch]="state.filter.type"
            [class.expanded]="state.filter.isExpanded"
            class="filter-content">
            <multi-filter-typeahead
              *ngSwitchCase="multiFilterType.LocationTypeahead"
              #ref
              [configuration]="getTypeaheadConfig(state.filter, ref)"
              (filterUpdated)="updateFilters(state.filter, $event)"
              (optionsSelectedCountUpdated)="
                updateSelectedOptionCount(state.filter, $event)
              "
              (errorOccurred)="errorOccured($event)"
              (loadComplete)="
                loadComplete(state.filter, $event)
              "></multi-filter-typeahead>

            <multi-filter-typeahead
              #ref
              *ngSwitchCase="multiFilterType.PositionTypeahead"
              [configuration]="getTypeaheadConfig(state.filter, ref)"
              (filterUpdated)="updateFilters(state.filter, $event)"
              (optionsSelectedCountUpdated)="
                updateSelectedOptionCount(state.filter, $event)
              "
              (errorOccurred)="errorOccured($event)"
              (loadComplete)="
                loadComplete(state.filter, $event)
              "></multi-filter-typeahead>

            <checkbox-list
              #ref
              *ngSwitchCase="multiFilterType.CheckboxList"
              [configuration]="getCheckboxListConfig(state.filter, ref)"
              (filterUpdated)="updateFilters(state.filter, $event)"
              (optionsSelectedCountUpdated)="
                updateSelectedOptionCount(state.filter, $event)
              "></checkbox-list>

            <text-input
              #ref
              *ngSwitchCase="multiFilterType.TextInput"
              [configuration]="getTextInputConfig(state.filter, ref)"
              (filterUpdated)="updateFilters(state.filter, $event)"
              (optionsSelectedCountUpdated)="
                updateSelectedOptionCount(state.filter, $event)
              "></text-input>

            <date-range
              #ref
              *ngSwitchCase="multiFilterType.DateRange"
              [configuration]="getDateRangeConfig(state.filter, ref)"
              (filterUpdated)="updateFilters(state.filter, $event)"
              (optionsSelectedCountUpdated)="
                updateSelectedOptionCount(state.filter, $event)
              ">
            </date-range>

            <radio-button-list
              #radioButtonListRef
              *ngSwitchCase="multiFilterType.RadioButtonList"
              [configuration]="
                getRadioButtonListConfig(state.filter, radioButtonListRef)
              "
              (filterUpdated)="updateFilters(state.filter, $event)">
            </radio-button-list>
          </div>
        </div>
      </div>

      <div class="sticky-footer">
        <button
          mat-button
          color="action"
          class="mat-button full-width"
          [disabled]="hideSubmit"
          (mousedown)="drawer.toggle(); setNewFilters()"
          (mouseup)="hideSubmit = true">
          Show Results
        </button>
      </div>
    </div>
  </mat-drawer>
</mat-drawer-container>
